import { Box, LoadingOverlay } from '@mantine/core';
import { EmailBoxContextProvider } from '../../Service/Context/EmailBoxContext';
import EmailsSection from '../../Organismns/Message/EmailsSection';
import { useContactDetails } from '../../Service/Context/ContactDetailsContext';

const ContactMessaging = () => {
  const { loading, contact } = useContactDetails();
  const { id: contactId } = contact ?? {};

  if (loading) {
    return (
      <Box pos="relative" sx={{ height: '100%', width: '100%' }}>
        <LoadingOverlay visible loaderProps={{ size: 'xl' }} />
      </Box>
    );
  }

  if (!contactId) return null;

  return (
    <EmailBoxContextProvider contactIds={[contactId]}>
      <EmailsSection />
    </EmailBoxContextProvider>
  );
};

export default ContactMessaging;
